import { inject, Injectable, signal } from '@angular/core';
import { IndexedDBService } from '../browser/indexed-db.service';
import { ENVIRONMENT_TOKEN, TIDBConnection } from '@aksia/infrastructure';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AzureStorageMockService extends IndexedDBService {
  protected environment = inject(ENVIRONMENT_TOKEN);
  protected http = inject(HttpClient);
  private dbSchema = signal<TIDBConnection | undefined>(undefined);

  async init(settings: any, containerName: string): Promise<boolean> {
    this.dbSchema.set({
      name: 'AzureStorageMock',
      version: 1,
      tables: [{ name: containerName, keyPath: ['id'], autoIncrement: false }],
    });
    await this.createDatabase(this.dbSchema()!);
    let ids = await this.listAllIds(this.dbSchema()!.name, containerName);
    if (!ids?.includes('Aksia')) {
      let data = await this._getDefaultAksiaViews();
      if (data) {
        this.insert(this.dbSchema()!.name, containerName, {
          id: 'Aksia',
          data: JSON.stringify(data),
        });
      }
    }
    return true;
  }

  async uploadFile(
    containerName: string,
    blobName: string,
    blobData: unknown,
  ): Promise<string> {
    const data = {
      id: blobName,
      data: blobData,
    };
    let result = await this.update(this.dbSchema()!.name, containerName, data);

    return result;
  }

  async listBlobs(containerName: string): Promise<string[] | undefined> {
    const result = await this.listAllIds(this.dbSchema()!.name, containerName);
    return result;
  }

  async downloadBlobAsText(
    containerName: string,
    blobName: string,
  ): Promise<string> {
    const result = (await this.get(
      this.dbSchema()!.name,
      containerName,
      blobName,
    )) as {
      id: string;
      data: string;
    };
    if (result) {
      return result.data;
    } else {
      return Promise.resolve('');
    }
  }

  private async _getDefaultAksiaViews() {
    const route = `mock/storage/documentManagerViews/Aksia.json`;
    return fetch(route).then((response) => {
      if (!response.ok) {
        throw new Error('Could not fetch the default Aksia views');
      }
      return response.json();
    });
  }
}
